import React from 'react';
import { Typography, Card, CardContent, CardMedia } from '@mui/material';

interface CourseProps {
  image: string;
  description: string;
}

export const SimpleCalloutBox: React.FC<CourseProps> = ({ image, description }) => {
  return (
    <Card
      sx={{
        textAlign: 'center',
        alignItems: 'center',
        flex: '1',
        justifyContent: 'center',
      }}
    >
      <CardMedia
        component="img"
        image={image}
        alt="icon"
        sx={{
          width: { sm: '100%', xs: '50%' },
          maxWidth: '175px',
          maxHeight: '180px',
          margin: 'auto',
          padding: '1rem',
        }}
      />
      <CardContent>
        <Typography>{description}</Typography>
      </CardContent>
    </Card>
  );
};
